import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { HomeComponent } from './layout/home/home.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { AuthGuard } from './core/guards/auth.guard';
import { ProfileGuard } from './core/guards/profile.guard';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: HomeComponent,
        canActivate: [ProfileGuard],
        pathMatch: 'full',
        data: { titleKey: 'HomePage' },
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./features/profile/profile.module').then(
            (m) => m.ProfileModule,
          ),
      },
      {
        path: 'workshop',
        canActivate: [ProfileGuard],
        loadChildren: () =>
          import('./features/workshop/workshop.module').then(
            (m) => m.WorkshopModule,
          ),
      },
      {
        path: 'held-workshop',
        canActivate: [ProfileGuard],
        loadChildren: () =>
          import('./features/held-workshop/held-workshop.module').then(
            (m) => m.HeldWorkshopModule,
          ),
      },
      {
        path: 'e-workshop',
        canActivate: [ProfileGuard],
        loadChildren: () =>
          import('./features/e-workshop/e-workshop.module').then(
            (m) => m.EWorkshopModule,
          ),
      },
      {
        path: 'feedback',
        canActivate: [ProfileGuard],
        loadChildren: () =>
          import('./features/feedback/feedback.module').then(
            (m) => m.FeedbackModule,
          ),
      },
      {
        path: 'message',
        canActivate: [ProfileGuard],
        loadChildren: () =>
          import('./features/message/message.module').then(
            (m) => m.MessageModule,
          ),
      },
      {
        path: '**',
        component: PageNotFoundComponent,
      },
    ],
  },
  {
    path: 'login',
    redirectTo: '/auth/login/',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
